export default __webpack_public_path__ + "static/brandLogo-6888b028483c346e48e61e6aa01c5f69.png";